import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './RestaurantPage.scss';

export const RestaurantPage: FC = (): ReactElement => (
    <Page className="restaurant-page">
        <ConnectedPageHelmet appRoute={AppRoute.restaurant} />
        <ConnectedBlockRenderer appRoute={AppRoute.restaurant} />
    </Page>
);
